export default "__VITE_ASSET__DckHXSNy__"